import axios from 'axios'

// 用环境变量里的「公共前缀」
const baseURL = process.env.VUE_APP_API_PREFIX
const apiInstance = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  },
})

// 如果你需要带 cookie
// apiInstance.defaults.withCredentials = true

export default apiInstance



// WEBPACK FOOTER //
// ./src/utils/request.js